<template>
  <div class="hc-hexastack">
    <svg :style="style" class="hc-hexastack-chart">
      <g
        v-for="(text, index) in texts"
        :key="index"
        class="hc-hexastack-legend"
      >
        <text
          v-for="(part, idx) in parts(text)"
          :key="idx"
          :y="getLegendY(index)"
          :dx="getLegendX()"
          :dy="lineHeight * idx"
          :text-anchor="direction === 'ltr' ? 'end' : 'start'"
        >{{part}}</text>
      </g>
      <hexastack
        transform="translate(13.856, 16)"
        :data="Data"
        :curve="curve"
        :colors="colors"
        :offColor="offColor"
        :size="size"
        :columns="columns"
        :rows="rows"
        :horizontal="horizontal"
        :direction="direction"
        :scale="scale"
        :gradientSpread="gradientSpread"
        :onHover="onHover"
        class="hc-hexastack-pile"
      />
    </svg>
  </div>
</template>

<script>
import Hexastack from '../Hexastack'
import tween from '../libraries/tween'
export default {
  name: 'HexaStackChart',
  components: {
    Hexastack
  },
  props: {
    data: {
      type: Array,
      default () { return []}
    },
    texts: {
      type: Array,
      default () { return [] }
    },
    unit: {
      type: String,
      default: 'MD'
    },
    curve: {
      type: Number,
      default: 1
    },
    colors: {
      type: Array,
      default () { return ['#f56043']}
    },
    offColor: {
      type: String,
      default: '#757575'
    },
    size: {
      type: Number,
      default: 100
    },
    columns: {
      type: Number,
      default: 5
    },
    rows: {
      type: Number,
      default: 20
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    direction: {
      type: String,
      default: 'ltr'
    },
    lineHeight: {
      type: Number,
      default: 14
    },
    animation: {
      type: Boolean,
      default: true
    },
    animationDuration: {
      type: Number,
      default: 3000
    },
    animationOptions: {
      type: Object,
      default () {
        return {
          delay: 0,
          easing: 'Bounce',
          easingEdge: 'Out'
        }
      }
    },
    gradientSpread: {
      type: Number,
      default: .5
    }
  },
  data () {
    return {
      width: 340,
      height: 550,
      Data: []
    }
  },
  mounted () {
    this.resize()
    window.addEventListener('resize', this.resize)
  },
  created () {
    if (this.animation) {
      tween(
        Object.assign({}, this.data),
        Object.assign({}, this.data.map(() => {return 0})),
        this.animationDuration,
        (dataObject) => {
          this.Data = Object.keys(dataObject).map(function (key) { return dataObject[key] })
        }, this.animationOptions)
    } else {
      this.Data = this.data
    }
  },
  watch: {
    data: {
      handler (newData) {
        if (this.animation) {
          //newData.length = this.Data.length
          if (this.Data.length < newData.length) {
            for (let i = this.Data.length; i < newData.length; i++) {
              this.Data[i] = 0
            }
          } else {
            this.Data = this.Data.slice(0, newData.length)
          }
          tween(
            Object.assign({}, newData),
            Object.assign({}, this.Data),
            this.animationDuration,
            (dataObject) => {
            this.Data = Object.keys(dataObject).map(function (key) { return dataObject[key] })
          }, this.animationOptions)
        } else {
          this.Data = newData
        }
      },
      deep: true
    }
  },
  methods: {
    resize () {
      this.width = this.$el.offsetWidth
      this.height = this.$el.offsetHeight
    },
    getLegendY (index) {
      let y = 0
      if (this.data.length) {
        for (let i = 0; i < index; i++) {
          y += this.Data[i]
        }
        y += this.Data[index] / 2
      }
      return 5.3 * (y || 0) * this.scale
    },
    getLegendX () {
      return (this.direction === 'rtl' ? 190 : 150) * this.scale
    },
    invertDirection () {
      return this.direction === 'rtl' ? 'ltr' : 'rtl'
    },
    onHover (e, id, gid) {
      // console.log(this.texts[gid] + ': ' + this.data[gid] + ' ' + this.unit)
    },
    parts (text) {
      const threshold = text.length / 2 - 2
      const chunks = text.split(' ')
      let previous = ''
      let index = 0
      let parts = []
      for (let i = 0; i < chunks.length; i++) {
        let p = previous + ' ' + chunks[i]
        if (i === chunks.length - 1) {
          parts[index] = previous ? p : chunks[i]
        } else if (p.length > threshold) {
          if (i) {
            parts[index] = previous
            previous = chunks[i]
          } else {
            parts[index] = p
            previous = ''
          }
          index++
        } else {
          previous = p
        }
      }
      return parts
    }
  },
  computed: {
    style () {
      return { height: `${this.height}px`, width: `${this.width}px` }
    },
    scale () {
      return Math.min(this.width / (this.horizontal ? 530 : 340), this.height / (this.horizontal ? 340 : 530))
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resize)
  }
}
</script>

<style>

</style>
